import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { ApplicationType } from '@maia/config';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, map, Observable, of } from 'rxjs';
import { AppContextService } from '../services';

export const LoggedOutGuard: CanMatchFn = (): Observable<boolean> => {
  const securityService: OidcSecurityService = inject(OidcSecurityService);
  const appContext: AppContextService = inject(AppContextService);

  const activeApplication: ApplicationType | null = appContext.selectedApplication();
  if (!activeApplication) return of(true);

  return securityService.isAuthenticated(activeApplication).pipe(
    map((isAuthenticated: boolean) => !isAuthenticated),
    catchError(() => of(true)),
  );
};
